







import Vue from "vue";
import { ref } from "@vue/composition-api";
export default Vue.extend({
  setup() {
    const counter = ref(1);
    const toggle = () => {
      counter.value = counter.value + 1;
      const el = document.querySelector(".signiture") as HTMLElement;
      if (counter.value % 5 === 0) {
        el.animate([{ opacity: 1, transform: "scale(1)" }], {
          duration: 500,
          fill: "forwards",
          easing: "ease-out"
        });
      } else if (counter.value % 7 === 0) {
        el.animate([{ opacity: 0, transform: "scale(0.2)" }], {
          duration: 500,
          fill: "forwards",
          easing: "ease-out"
        });
      }
    };
    return {
      toggle,
      counter
    };
  }
});
